import { FC, ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

interface KioskAuthGuardProps {
    children: ReactNode;
}

/**
 * KioskAuthGuard — protects routes that require an authenticated session.
 *
 * Reads auth state from Redux (kioskAuthSlice), which is only populated after
 * the server-side session verification in kiosk-routes.tsx completes.
 * By the time this guard renders, isAuthChecking is guaranteed to be false,
 * so routing decisions are always based on verified server state.
 */
const KioskAuthGuard: FC<KioskAuthGuardProps> = ({ children }) => {
    const location = useLocation();    
    const { isLoggedIn, isPhoneVerified } = useSelector((state: any) => state.kioskAuthSlice);


    // Not authenticated → go to login
    if (!isLoggedIn) {
        return <Navigate to="/login" replace />;
    }

    // Authenticated but phone not yet verified → send to verify
    if (!isPhoneVerified && location.pathname !== '/verify') {
        return <Navigate to="/verify" replace />;
    }

    // Fully authenticated → allow access
    return <>{children}</>;
};

export default KioskAuthGuard;
